export default "__VITE_ASSET__CkaWFPXn__"